const Chart1 = () => {
    return (
        <>
            <div className="card custom-card p-2 weather-card">
                <div className="card-header">
                    <div className="w-100">
                        <h4 className="mb-1">토양샘플링결과</h4>
                        <div className="d-flex justify-content-between">
                            <div>
                                <div className="lunar-date text-gray-7">
                                    분석기관: 서울대학교 농업생명과학 공동기기원
                                </div>
                                <div className="lunar-date text-gray-7">
                                    발급번호: 공동기기 2022-004-4
                                </div>
                            </div>

                            <div
                                aria-label="Basic example"
                                role="group"
                                className="flex-wrap btn-group btn-group-sm"
                            >
                                <button
                                    type="button"
                                    className="btn-wave btn btn-success"
                                >
                                    1층(20cm)
                                </button>
                                <button
                                    type="button"
                                    className="btn-wave btn btn-success-light"
                                >
                                    2층(40cm)
                                </button>
                                <button
                                    type="button"
                                    className="btn-wave btn btn-success-light"
                                >
                                    3층(60cm)
                                </button>
                                <button
                                    type="button"
                                    className="btn-wave btn btn-success-light"
                                >
                                    4층(80cm)
                                </button>
                                <button
                                    type="button"
                                    className="btn-wave btn btn-success-light"
                                >
                                    5층(100cm)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body weather-info">
                    <h6>토양성분</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            pH
                        </div>
                        <div className="col-12 col-sm-3 weather-item">6.6</div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            EC (전기전도도)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            0.72 dS/m
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            유기물함량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            1.77 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            TOC (전유기탄소)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            1.03 %
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            T-N (전질소)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            0.115 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            NH₄⁺ (암모니아)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            8.42 mg/kg
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            NO₃⁻ (질산)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            32.99 mg/kg
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>

                    <h6 className="mt-2">염기포화도</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            CEC (양이온치환용량)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            11.99 cmol/kg
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            치환성Ca
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            1102.64 mg/kg
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            치환성 Mg
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            116.08 mg/kg
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            치환성 K
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            260.08 mg/kg
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            P₂O₅ (유효인산)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            436.16 mg/kg
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>

                    <h6 className="mt-2">용적밀도</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            용적밀도
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            1.28 g/cm³
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            고상
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            51.63 %
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            액상
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            26.89 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            기상
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            21.48 %
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            공극률
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            48.31 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>

                    <h6 className="mt-2">토양 비율</h6>
                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            Soil texture(토성)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            사양토
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            Sand(사토)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            10.12 %
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            Silt(미사토)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            80.12 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            Clay(식토)
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            20.12 %
                        </div>
                    </div>

                    <div className="row weather-grid">
                        <div className="col-12 col-sm-3 weather-item weather-item-header">
                            수분함량
                        </div>
                        <div className="col-12 col-sm-3 weather-item">
                            17.4 %
                        </div>
                        <div className="col-12 col-sm-3 weather-item weather-item-header"></div>
                        <div className="col-12 col-sm-3 weather-item"></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart1;
